import { Resources } from 'constants/resources';

import { hydraSchemaAnalyzer } from '@api-platform/admin';
import { ProvidersShowWhiteIpAddressesForm } from 'pages/Providers/ProvidersShow/ProvidersShowWhiteIpAddresses/components/ProvidersShowWhiteIpAddressesForm';
import { useCreateProviderWhiteIpAddressesBulk } from 'pages/Providers/ProvidersShow/ProvidersShowWhiteIpAddresses/hooks/useCreateProviderWhiteIpAddressesBulk';
import { Form, HttpError, Identifier, useNotify, useRefresh } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { getServerErrorMessage } from 'utils/getServerErrorMessage';

import { CreateStyled } from './ProvidersShowWhiteIpAddressesCreateDialog.styled';

type WhiteIpAddressesBulkFormValues = {
  ip: string[];
  mask: string;
  comment: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  provider?: Identifier;
};

export const ProvidersShowWhiteIpAddressesCreateDialog: React.FC<Props> = ({
  open,
  onClose,
  provider,
}) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const { mutateAsync: createBulk } = useCreateProviderWhiteIpAddressesBulk();

  const onSubmit = async (formValues: WhiteIpAddressesBulkFormValues) => {
    try {
      await createBulk({
        provider,
        ips: formValues.ip,
        mask: Number(formValues.mask),
        comment: formValues.comment ?? '',
      });
      notify('Белые IP адреса успешно созданы!', {
        type: 'success',
      });
      refresh();
      onClose();
    } catch (error) {
      const submissionErrors = hydraSchemaAnalyzer().getSubmissionErrors(error as HttpError);
      if (submissionErrors) {
        return submissionErrors;
      }
      notify(`Ошибка: ${await getServerErrorMessage(error)}`, { type: 'error' });
    }
  };

  return (
    <Dialog fullWidth onClose={onClose} open={open}>
      <CreateStyled resource={Resources.ProviderWhiteIpAddresses} sx={{ margin: 0 }}>
        <Form onSubmit={onSubmit as any}>
          <CardHeader
            appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
            title="Добавление белого IP"
            titleSize="smallBold"
          />
          <ProvidersShowWhiteIpAddressesForm multiple />
          <CardActionsButtons
            rightActionsSlot={[
              <Button key="cancel" label="Отменить" onClick={onClose} variant="outlined" />,
              <Button key="create" label="Создать" type="submit" variant="contained" />,
            ]}
          />
        </Form>
      </CreateStyled>
    </Dialog>
  );
};
